import { images } from '../constants';
import { FaTree, FaMapSigns, FaCamera, FaCalendarAlt, FaHandshake, FaEnvelope } from 'react-icons/fa';

const services = [  
    {
        id: 1,
        image: images.service1, 
        icon: <FaTree />,
        titleKey: 'services.item1.title',
        contentKey: 'services.item1.content',
        paragraphsKeys: [
            'services.item1.paragraphs.0',
            'services.item1.paragraphs.1',
            'services.item1.paragraphs.2',
            'services.item1.paragraphs.3',
        ],
        gallery: [
            images.service1Gallery1
        ],
        featuresKey: 'services.item1.features',
    },
    {
        id: 2,
        image: images.service2,
        icon: <FaMapSigns />,
        titleKey: 'services.item2.title',
        contentKey: 'services.item2.content',
        paragraphsKeys: [
            'services.item2.paragraphs.0',
            'services.item2.paragraphs.1',
            'services.item2.paragraphs.2',
            'services.item2.paragraphs.3',
        ],
        gallery: [
            images.service2Gallery1
        ],
        featuresKey: 'services.item2.features',
    },
    {
        id: 3,
        image: images.service3,
        icon: <FaCamera />,
        titleKey: 'services.item3.title',
        contentKey: 'services.item3.content',
        paragraphsKeys: [
            'services.item3.paragraphs.0',
            'services.item3.paragraphs.1',
            'services.item3.paragraphs.2',
            'services.item3.paragraphs.3',
        ],
        gallery: [
            images.service3Gallery1
        ],
        featuresKey: 'services.item3.features',
    },
    {
        id: 4,
        image: images.service4,
        icon: <FaCalendarAlt />,
        titleKey: 'services.item4.title',
        contentKey: 'services.item4.content',
        paragraphsKeys: [
            'services.item4.paragraphs.0',
            'services.item4.paragraphs.1',
            'services.item4.paragraphs.2',
            'services.item4.paragraphs.3',
        ],
        gallery: [
            images.service4Gallery1
        ],
        featuresKey: 'services.item4.features',
    },
    {
        id: 5,
        image: images.service5,
        icon: <FaHandshake />,
        titleKey: 'services.item5.title',
        contentKey: 'services.item5.content',
        paragraphsKeys: [
            'services.item5.paragraphs.0',
            'services.item5.paragraphs.1',
            'services.item5.paragraphs.2',
            'services.item5.paragraphs.3',
        ],
        gallery: [
            images.service5Gallery1
        ],
        featuresKey: 'services.item5.features',
    },
    {
        id: 6,
        image: images.service6,
        icon: <FaEnvelope />,
        titleKey: 'services.item6.title',
        contentKey: 'services.item6.content',
        paragraphsKeys: [
            'services.item6.paragraphs.0'
        ],
        gallery: [
            images.service6Gallery1
        ],
        featuresKey: 'services.item6.features',
    },
];

export default services;